export enum PaymentReportVariant
{
  Simple,
  Consolidated,
}
